import React from "react";

const challenges = [
  {
    number: <div class="number fontColor1">1</div>,
    heading: "Marketing Solutions",
    description:
      "IT companies can help IVF centers create and implement effective digital marketing strategies to attract new patients and increase brand awareness.",
  },
  {
    number: <div class="number fontColor2">2</div>,
    heading: "Data Analytics",
    description:
      "IT companies can use data analytics to help IVF centers analyze patient data, identify trends, and improve patient outcomes.",
  },
  {
    number: <div class="number fontColor3">3</div>,
    heading: "Patient Management System",
    description:
      "IT companies can develop customized patient management systems to help IVF centers manage patient appointments, track patient progress, and provide follow-up care.",
  },
  {
    number: <div class="number fontColor4">4</div>,
    heading: "Billing and Payment Systems",
    description:
      "Implementing a digital billing and payment system can help IVF centers reduce errors, increase efficiency, and improve patient satisfaction.",
  },
];

class Challenges extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding dfbb7680978 p-b10 bg-repeat">
          <div className="container p-t80">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner mb__30">
                  <h2 class="ert678">The Solutions</h2>
                </div>
              </div>
              <div className="col-md-12 sx-separator-outer separator-center"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul class="infoGraphic">
                  {challenges.map((item, index) => (
                    <li>
                      <div class="numberWrap">
                        {item.number}
                        <div class="coverWrap">
                          <div class="numberCover"></div>
                        </div>
                      </div>
                      <div class="content">
                        <h3>{item.heading}</h3>
                        <p>{item.description}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Challenges;
